export { type LicensePackage, findDependencyLicenses } from './licenses.ts';
